import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import { toUrl } from '../lib/config';

const DuzenleyiciOnleyiciFaaliyetPage: React.FC = () => {
  const [formData, setFormData] = useState({
    dofNo: '',
    tarih: '',
    dofTalepEden: '',
    dofInKonusu: 'Öz Değerlendirme',
    diger: '',
    dofSorumlusu: 'Kalite Birimi',
    adi: '',
    planlayanDuzenleyici: '',
    gerceklesenFaaliyetler: '',
    sonuc: '',
    dofKapatanınAdi: '',
    basariliKapandi: '',
    basarisizKapandi: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError('');
      setSuccess(false);

      const url = toUrl('/api/duzenleyici-onleyici-faaliyet');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Form gönderilemedi. Lütfen tekrar deneyin.');
      }

      setSuccess(true);
      setFormData({
        dofNo: '',
        tarih: '',
        dofTalepEden: '',
        dofInKonusu: 'Öz Değerlendirme',
        diger: '',
        dofSorumlusu: 'Kalite Birimi',
        adi: '',
        planlayanDuzenleyici: '',
        gerceklesenFaaliyetler: '',
        sonuc: '',
        dofKapatanınAdi: '',
        basariliKapandi: '',
        basarisizKapandi: ''
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="anket-page">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h6 className="text-muted mb-2">Bize ulaşın</h6>
          <h1 className="mb-3">
            İletişim
          </h1>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            margin: '0 auto 20px' 
          }}></div>
          <p className="text-muted mb-3" style={{ maxWidth: '600px', margin: '0 auto 15px' }}>
            Megapark Hastanesi her an ve her zaman sizin yanınızda
          </p>
          <div style={{ 
            width: '100%', 
            height: '1px', 
            backgroundColor: '#ddd', 
            margin: '0' 
          }}></div>
        </div>

        <div className="mt-5">
          <h4 className="mb-2 fw-bold">Düzenleyici/ Önleyici Faaliyet Talep Formu</h4>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            marginBottom: '30px' 
          }}></div>

          {/* Başarı Mesajı */}
          {success && (
            <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
              <Alert.Heading>Teşekkür Ederiz!</Alert.Heading>
              <p>
                DÖF talebi başarıyla gönderildi. Kayıt sisteme eklendi.
              </p>
            </Alert>
          )}

          {/* Hata Mesajı */}
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              <Alert.Heading>Hata!</Alert.Heading>
              <p>{error}</p>
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="survey-form">
            {/* DÖF No */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                DÖF No
              </Form.Label>
              <Form.Control
                type="text"
                name="dofNo"
                value={formData.dofNo}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ 
                  backgroundColor: '#f5f5f5',
                  maxWidth: '200px'
                }}
              />
            </Form.Group>

            {/* Tarih */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Tarih
              </Form.Label>
              <Form.Control
                type="date"
                name="tarih"
                value={formData.tarih}
                onChange={handleChange}
                placeholder="gg.aa.yyyy"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* DÖF Talep Eden */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                DÖF Talep Eden
              </Form.Label>
              <Form.Control
                type="text"
                name="dofTalepEden"
                value={formData.dofTalepEden}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* DÖF'ün Konusu */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                DÖF'ün Konusu
              </Form.Label>
              <Form.Select
                name="dofInKonusu"
                value={formData.dofInKonusu}
                onChange={handleChange}
                required
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              >
                <option value="Öz Değerlendirme">Öz Değerlendirme</option>
                <option value="Hasta Şikayeti">Hasta Şikayeti</option>
                <option value="Çalışan Önerisi">Çalışan Önerisi</option>
                <option value="Denetim">Denetim</option>
                <option value="Diğer">Diğer</option>
              </Form.Select>
            </Form.Group>

            {/* Diğer */}
            <Form.Group className="mb-4">
              <Form.Control
                type="text"
                name="diger"
                value={formData.diger}
                onChange={handleChange}
                placeholder="Diğer..."
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* DÖF Sorumlusu */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                DÖF Sorumlusu
              </Form.Label>
              <Form.Select
                name="dofSorumlusu"
                value={formData.dofSorumlusu}
                onChange={handleChange}
                required
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              >
                <option value="Kalite Birimi">Kalite Birimi</option>
                <option value="Tıbbi Birim">Tıbbi Birim</option>
                <option value="İdari Birim">İdari Birim</option>
                <option value="Teknik Birim">Teknik Birim</option>
              </Form.Select>
            </Form.Group>

            {/* Adı */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Adı
              </Form.Label>
              <Form.Control
                type="text"
                name="adi"
                value={formData.adi}
                onChange={handleChange}
                placeholder="Adı"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Planlayan Düzenleyici Önleyici Faaliyetler */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Planlayan Düzenleyici Önleyici Faaliyetler
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="planlayanDuzenleyici"
                value={formData.planlayanDuzenleyici}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Gerçekleşen Faaliyetler */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Gerçekleşen Faaliyetler
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="gerceklesenFaaliyetler"
                value={formData.gerceklesenFaaliyetler}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Sonuç */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Sonuç
              </Form.Label>
              <Form.Control
                type="date"
                name="sonuc"
                value={formData.sonuc}
                onChange={handleChange}
                placeholder="gg.aa.yyyy"
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* DÖF'ü Kapatanın Adı Soyadı */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                DÖF'ü Kapatanın Adı Soyadı
              </Form.Label>
              <Form.Control
                type="text"
                name="dofKapatanınAdi"
                value={formData.dofKapatanınAdi}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Başarılı Kapandı / Başarısız Kapandı Radio Buttons */}
            <Form.Group className="mb-4">
              <div className="mb-3">
                <Form.Check
                  type="radio"
                  id="basariliKapandi"
                  name="kapanmaDurumu"
                  label="Başarılı Kapandı"
                  value="basarili"
                  checked={formData.basariliKapandi === 'basarili'}
                  onChange={(e) => setFormData(prev => ({ ...prev, basariliKapandi: e.target.value, basarisizKapandi: '' }))}
                  className="mb-2"
                />
                <Form.Check
                  type="radio"
                  id="basarisizKapandi"
                  name="kapanmaDurumu"
                  label="Başarısız Kapandı"
                  value="basarisiz"
                  checked={formData.basarisizKapandi === 'basarisiz'}
                  onChange={(e) => setFormData(prev => ({ ...prev, basarisizKapandi: e.target.value, basariliKapandi: '' }))}
                />
              </div>
            </Form.Group>

            {/* Submit Button */}
            <div className="mt-4">
              <Button
                type="button"
                size="lg"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e as any);
                }}
                style={{
                  backgroundColor: '#4CAF50',
                  borderColor: '#4CAF50',
                  fontWeight: '600',
                  padding: '12px 40px',
                  borderRadius: '25px'
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  'Gönder'
                )}
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </div>
  );
};

export default DuzenleyiciOnleyiciFaaliyetPage;
